
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Employee from '@/models/Employee';
import ContactInfo from '@/models/ContactInfo';
import User from '@/models/User';
import Skill from '@/models/Skill';
import CurrencyField from '@/components/CurrencyField.vue';
import { TaskCategories } from '@/models/Task';

@Component({
  components: {
    'currency-field': CurrencyField
  }
})
export default class EmployeeSkills extends Vue {
  skill = { name: '', level: 0, rate: 0 };
  oldSkill = { name: '', level: 0, rate: 0 };
  valid = false;
  formMode = false;
  editing = false;
  loading = false;
  skillNameRules = [];
  rateRules = [];
  money = {
    thousands: ',',
    precision: 0,
    masked: false
  };
  thousandsSeparatorRegex = new RegExp(',', 'g');
  taskCategories = TaskCategories;

  @Getter
  currentUser: User;

  created() {
    this.skillNameRules = [
      v => !!v || 'Skill Name is required',
      v => this.editing || !this.currentUser.employee.skills.find(s => s.name === v) || 'Skill Name is already existed'
    ];
    this.rateRules = [v => !!v || 'Rate is required'];
  }

  submit() {
    this.loading = true;
    if (this.editing) {
      this.editSkill();
    } else {
      this.addSkill();
    }
  }

  showEditForm(skill: Skill) {
    this.formMode = true;
    this.editing = true;
    this.skill.name = skill.name;
    this.skill.level = skill.level;
    this.skill.rate = skill.rate;
    this.oldSkill = Object.assign({}, this.skill);
  }

  addSkill() {
    this.loading = true;
    this.$store.dispatch('addSkill', this.skill).then(_ => {
      this.loading = false;
      this.reset();
    });
  }

  editSkill() {
    this.loading = true;
    this.$store.dispatch('editSkill', { oldSkill: this.oldSkill, newSkill: this.skill }).then(_ => {
      this.loading = false;
      this.reset();
    });
  }

  deleteSkill(skill: Skill) {
    this.loading = true;
    this.$store.dispatch('deleteSkill', skill).then(_ => {
      this.loading = false;
    });
  }

  showForm() {
    this.formMode = true;
  }

  reset() {
    this.formMode = false;
    this.editing = false;
    this.skill = { name: '', level: 0, rate: 0 };
  }

  levelSelected() {
    return [1, 2, 3].includes(this.skill.level);
  }

  isValid() {
    return this.valid && this.levelSelected() && !this.loading;
  }

  back() {
    this.$router.back();
  }
}
